import React from 'react';

import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import styled from 'styled-components';

import theme from 'constants/theme';

import { getProgressBarColor } from '../../common';

export const PROGRESS_KEYS = {
  BUILDING: 'BUILDING',
  EXCELLED: 'EXCELLED',
  NOT_CRITICAL: 'NOT_CRITICAL',
  SKILLED: 'SKILLED',
  STARTING: 'STARTING',
  NOT_ENOUGH_DATA: 'NOT_ENOUGH_DATA',
};

export const TARGET_ROLE_KEYS = {
  CURRENT_ROLE: 'CURRENT_ROLE',
  NOT_SET: 'NOT_SET',
  TARGET_ROLE: 'TARGET_ROLE',
  NEW_ROLE: 'NEW_ROLE',
};

const KEYS_FOR_PROGRESS_CELL = Object.keys(PROGRESS_KEYS);

const ProgressBar = ({ progress }) => {
  let modifiedData = { ...progress };

  KEYS_FOR_PROGRESS_CELL.forEach((k) => {
    if (modifiedData[k] && modifiedData[k]?.percentage && +modifiedData[k]?.percentage === 0) {
      try {
        modifiedData = { ...modifiedData, [k]: { ...modifiedData[k], percentage: 1 } };
      } catch (err) {
        console.error('Error in setting value : ', err);
      }
    }
  });

  const sumOfAllCompletionPercentage = Object?.values(progress)?.map((v) => {
    if (v && v.percentage) {
      return v.percentage;
    }
    return 0;
  });

  const BASE_TRACK = {
    percentage: 100 - +sumOfAllCompletionPercentage.reduce((pre, curr) => +pre + +curr, 0),
  };

  return (
    <ResponsiveContainer width="100%" height={10}>
      <StyledBarChart
        layout="vertical"
        data={[{ ...modifiedData, BASE_TRACK }]}
        margin={{
          top: 10,
          right: 0,
          bottom: 10,
          left: 0,
        }}
        stackOffset="expand"
      >
        <XAxis hide type="number" />
        <YAxis type="category" hide />
        {modifiedData.EXCELLED !== null && (
          <Bar dataKey="EXCELLED.percentage" fill={getProgressBarColor('EXCELLED')} stackId="a" />
        )}
        {modifiedData.SKILLED !== null && (
          <Bar dataKey="SKILLED.percentage" fill={getProgressBarColor('SKILLED')} stackId="a" />
        )}
        {modifiedData.BUILDING !== null && (
          <Bar dataKey="BUILDING.percentage" fill={getProgressBarColor('BUILDING')} stackId="a" />
        )}

        {modifiedData.NOT_CRITICAL !== null && (
          <Bar dataKey="NOT_CRITICAL.percentage" fill={getProgressBarColor('NOT_CRITICAL')} stackId="a" />
        )}

        {modifiedData.STARTING !== null && (
          <Bar dataKey="STARTING.percentage" fill={getProgressBarColor('STARTING')} stackId="a" />
        )}

        <Bar dataKey="BASE_TRACK.percentage" fill={theme.palette.background.lightGrey3} stackId="a" />
      </StyledBarChart>
    </ResponsiveContainer>
  );
};

const StyledBarChart = styled(BarChart)`
  .recharts-surface {
    border-radius: 8rem;
  }
`;

export default ProgressBar;
